var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _g2, _path15, _path16, _path17, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFdPublished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 635,
    height: 635,
    viewBox: "0 0 635 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.45 439.214C445.076 547.036 303.051 579.825 195.229 512.45C87.407 445.076 54.6179 303.051 121.993 195.229C189.367 87.407 331.392 54.6179 439.214 121.993C547.036 189.367 579.825 331.392 512.45 439.214Z",
    fill: "#F7FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.447 429.84C435.25 529.376 304.14 559.645 204.604 497.448C105.068 435.251 74.7986 304.141 136.996 204.605C199.193 105.069 330.303 74.7995 429.839 136.997C529.375 199.194 559.644 330.304 497.447 429.84Z",
    fill: "#EEF6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M466.433 410.591C414.951 492.978 306.429 518.033 224.042 466.551C141.655 415.07 116.6 306.548 168.082 224.161C219.563 141.773 328.085 116.719 410.472 168.201C492.86 219.682 517.914 328.204 466.433 410.591Z",
    fill: "#E5F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.226 354.769C364.296 332.344 359.259 326.86 349.627 322.211C348.518 321.676 347.191 322.084 346.539 323.128L328.351 352.235C327.679 353.31 327.941 354.716 328.915 355.528C338.033 363.126 341.493 371.586 340.339 394.913C340.239 396.947 342.441 398.203 344.052 396.956C352.581 390.35 371.485 373.371 368.226 354.769Z",
    fill: "#031C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M349.676 322.11C354.502 324.44 358.191 326.985 361.16 331.765C364.126 336.539 366.371 343.534 368.336 354.75C369.974 364.094 366.043 373.021 360.65 380.427C355.257 387.835 348.389 393.738 344.121 397.044C342.427 398.356 340.122 397.027 340.227 394.907C340.804 383.247 340.227 375.316 338.372 369.355C336.52 363.4 333.389 359.402 328.843 355.614C327.828 354.768 327.552 353.301 328.255 352.175L346.443 323.069C347.125 321.977 348.513 321.549 349.676 322.11ZM328.446 352.294C327.805 353.32 328.053 354.664 328.987 355.442C333.559 359.252 336.717 363.284 338.585 369.289C340.452 375.289 341.028 383.251 340.451 394.918C340.354 396.867 342.457 398.05 343.984 396.868C348.244 393.568 355.093 387.679 360.469 380.295C365.846 372.91 369.738 364.045 368.115 354.788C366.151 343.58 363.913 336.62 360.97 331.883C358.031 327.152 354.384 324.631 349.578 322.312C348.523 321.803 347.257 322.19 346.634 323.188L328.446 352.294Z",
    fill: "#031C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M261.148 287.86C283.026 281.561 290.163 283.684 298.564 290.304C299.531 291.066 299.746 292.437 299.094 293.482L280.906 322.588C280.234 323.664 278.855 324.045 277.698 323.525C266.872 318.66 257.752 319.259 237.292 330.522C235.507 331.504 233.412 330.075 233.828 328.081C236.026 317.519 243 293.085 261.148 287.86Z",
    fill: "#031C41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.633 290.216C294.424 286.899 290.519 284.7 284.921 284.126C279.33 283.553 272.059 284.602 261.117 287.752C252 290.377 245.701 297.823 241.408 305.916C237.114 314.011 234.818 322.772 233.718 328.058C233.281 330.155 235.486 331.644 237.346 330.62C247.573 324.991 254.954 322.032 261.125 321.086C267.29 320.141 272.255 321.202 277.653 323.627C278.858 324.168 280.297 323.773 281.001 322.648L299.189 293.541C299.871 292.45 299.647 291.015 298.633 290.216ZM280.81 322.529C280.169 323.554 278.852 323.921 277.744 323.423C272.316 320.984 267.307 319.912 261.091 320.866C254.88 321.818 247.472 324.791 237.238 330.424C235.528 331.365 233.543 329.994 233.937 328.103C235.035 322.827 237.326 314.09 241.606 306.022C245.886 297.951 252.148 290.568 261.179 287.967C272.114 284.819 279.351 283.78 284.898 284.349C290.439 284.917 294.304 287.09 298.494 290.392C299.415 291.117 299.622 292.425 298.998 293.422L280.81 322.529Z",
    fill: "#031C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M234.351 382.651C242.842 369.062 265.832 358.866 284.056 370.436C302.154 381.927 302.306 407.438 294.363 420.15C288.68 429.245 271.927 448.897 260.297 453.422C256.964 454.719 258.533 442.765 255.391 443.737C249.25 445.637 243.764 446.939 240.059 447.728C237.26 448.324 234.545 446.646 233.826 443.875C232.865 440.173 231.56 434.611 230.507 428.188C229.971 424.918 218.683 430.799 218.357 427.215C217.221 414.731 228.653 391.769 234.351 382.651Z",
    fill: "#90C7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.546 383.149C250.148 372.583 268.035 364.662 282.222 373.67C296.311 382.615 296.44 402.458 290.264 412.342C285.845 419.413 272.816 434.692 263.767 438.206C261.174 439.214 262.39 429.916 259.945 430.671C255.731 431.973 251.913 432.912 249.093 433.536C246.3 434.153 243.587 432.476 242.89 429.702C242.179 426.87 241.299 422.979 240.573 418.567C240.155 416.023 231.373 420.592 231.118 417.805C230.228 408.094 239.115 390.239 243.546 383.149Z",
    fill: "#A4D4FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M254.477 380.445C259.209 372.873 272.016 367.19 282.166 373.635C292.246 380.035 292.328 394.248 287.902 401.331C284.735 406.399 275.402 417.349 268.923 419.871C267.066 420.594 267.941 413.934 266.191 414.476C263.819 415.211 261.622 415.785 259.811 416.215C257.025 416.875 254.303 415.194 253.648 412.406C253.216 410.567 252.739 408.308 252.331 405.816C252.033 403.994 245.745 407.272 245.564 405.275C244.932 398.32 251.303 385.526 254.477 380.445Z",
    fill: "#F0F8FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M354.039 202.386C367.266 195.186 388.386 189.211 396.406 187.084C398.159 186.619 399.894 187.753 400.176 189.545C401.442 197.602 404.438 218.713 403.605 233.358C401.598 268.685 374.131 318.982 374.131 318.982C374.131 318.982 345.349 363.448 312.456 388.314C310.759 389.597 280.018 377.682 280.018 377.682C280.018 377.682 255.005 354.923 255.483 352.713C266.76 300.477 290.95 267.005 290.95 267.005C290.95 267.005 323.062 219.246 354.039 202.386Z",
    fill: "url(#paint0_linear_32049_18442)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M373.63 277.871C365.732 290.51 349.085 294.354 336.446 286.456C323.807 278.559 319.964 261.911 327.861 249.272C335.759 236.633 352.407 232.79 365.045 240.687C377.684 248.585 381.528 265.233 373.63 277.871Z",
    fill: "#031C41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.187 273.846C361.513 282.926 349.552 285.687 340.472 280.013C331.392 274.339 328.631 262.379 334.305 253.299C339.978 244.218 351.939 241.457 361.019 247.131C370.099 252.805 372.861 264.766 367.187 273.846Z",
    fill: "#CAE3FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.999 246.662C352.061 246.658 352.977 247.39 353.255 248.415C353.704 250.07 352.333 251.633 350.619 251.632C347.763 251.63 345.597 252.212 343.268 253.579C341.781 254.451 339.788 253.808 339.337 252.145C339.065 251.142 339.463 250.068 340.354 249.534C343.895 247.412 346.667 246.678 350.999 246.662Z",
    fill: "#E4F1FD",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32049_18442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 331,
    y: 244,
    width: 40,
    height: 39
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M367.187 273.846C361.513 282.926 349.552 285.687 340.472 280.013C331.392 274.339 328.63 262.379 334.304 253.299C339.978 244.218 351.939 241.457 361.019 247.131C370.099 252.805 372.861 264.766 367.187 273.846Z",
    fill: "#CAE3FE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32049_18442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.682 258.301L372.083 267.15L334.251 277.417L331.849 268.568L369.682 258.301Z",
    fill: "#E4F1FD",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.903 272.746L374.408 278.292L336.575 288.559L335.07 283.013L372.903 272.746Z",
    fill: "#E4F1FD",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.701 252.837L366.292 255.017L328.46 265.284L327.868 263.104L365.701 252.837Z",
    fill: "#E4F1FD",
    fillOpacity: 0.26
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_32049_18442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 186,
    width: 149,
    height: 203
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M354.039 202.386C367.266 195.186 388.386 189.211 396.406 187.084C398.159 186.619 399.894 187.753 400.176 189.545C401.442 197.602 404.438 218.713 403.605 233.358C401.598 268.685 374.131 318.982 374.131 318.982C374.131 318.982 345.349 363.448 312.456 388.314C310.759 389.597 280.018 377.682 280.018 377.682C280.018 377.682 255.005 354.923 255.483 352.713C266.76 300.477 290.95 267.005 290.95 267.005C290.95 267.005 323.062 219.246 354.039 202.386Z",
    fill: "url(#paint1_linear_32049_18442)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_32049_18442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.514 130.354L454.933 172.481L409.838 244.648L342.42 202.52L387.514 130.354Z",
    fill: "url(#paint2_linear_32049_18442)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255.317 352.478L312.101 387.96L307.71 394.987L250.926 359.504L255.317 352.478Z",
    fill: "#002151"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250.927 359.505L307.71 394.987L302.722 410.371C302.363 411.479 301.057 411.955 300.069 411.337L239.581 373.54C238.592 372.923 238.447 371.541 239.286 370.731L250.927 359.505Z",
    fill: "#031C41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_32049_18442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 291,
    width: 68,
    height: 73
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M342.403 314.208L306.466 291.752L275.967 340.559L311.905 363.015L342.403 314.208Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_32049_18442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.166 314.06L299.278 303.254L275.963 340.566L318.847 351.378L342.166 314.06ZM330.312 318.559L303.053 311.668L296.16 322.699L323.414 329.599L330.312 318.559ZM287.811 336.061L294.773 324.918L308.432 328.33L301.465 339.48L287.811 336.061Z",
    fill: "#041D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32049_18442",
    x1: 381.133,
    y1: 307.778,
    x2: 297.822,
    y2: 255.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201923,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32049_18442",
    x1: 381.133,
    y1: 307.778,
    x2: 297.822,
    y2: 255.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201923,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32049_18442",
    x1: 432.386,
    y1: 208.564,
    x2: 364.967,
    y2: 166.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "#031C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003078"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdPublished);
export default __webpack_public_path__ + "static/media/fd-published.16ac7481ea822f780629a193d1952253.svg";
export { ForwardRef as ReactComponent };